import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Shield, Instagram } from 'lucide-react';

const TelegramIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295l.213-3.053 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.643.135-.953l11.566-4.458c.538-.196 1.006.128.832.939z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-black border-t border-zinc-900 text-zinc-400 mt-24">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="font-bold tracking-[0.18em] text-white text-xl mb-4">
              HYDRO <span className="text-[#909090]">HEALTH</span>
            </div>
            <p className="text-sm leading-relaxed">
              Lab-tested research peptides. High-purity formulas, COAs for
              every batch, and worldwide shipping. For research use only.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://t.me/+Vpb7iDzOq4s3YWQ0"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Telegram"
                className="w-12 h-12 flex items-center justify-center rounded-full border border-zinc-800 text-zinc-400 hover:text-[#909090] hover:border-[#909090] transition-colors"
              >
                <TelegramIcon size={24} />
              </a>
              <a
                href="https://www.instagram.com/dublinpeps?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-12 h-12 flex items-center justify-center rounded-full border border-zinc-800 text-zinc-400 hover:text-[#909090] hover:border-[#909090] transition-colors"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 tracking-wide">Shop</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/shop" className="hover:text-[#909090]">Shop All</Link></li>
              <li><Link to="/shop?category=Featured+Blends" className="hover:text-[#909090]">Featured Blends</Link></li>
              <li><Link to="/shop?category=Supplements" className="hover:text-[#909090]">Supplements</Link></li>
              <li><Link to="/shop?category=Research+Topicals" className="hover:text-[#909090]">Research Topicals</Link></li>
              <li><Link to="/shop?category=Accessories" className="hover:text-[#909090]">Accessories</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 tracking-wide">Information</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-[#909090]">About Us</Link></li>
              <li><Link to="/coas" className="hover:text-[#909090]">Lab Tested COAs</Link></li>
              <li><Link to="/news" className="hover:text-[#909090]">News & Updates</Link></li>
              <li><Link to="/track" className="hover:text-[#909090]">Track Your Order</Link></li>
              <li><Link to="/contact" className="hover:text-[#909090]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 tracking-wide">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-0.5 text-[#909090]" />
                <span>info@hydrohealth.store</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 text-[#909090]" />
                <span>Hydro Health<br/>Dublin<br/>Ireland</span>
              </li>
              <li className="flex items-start gap-2">
                <Shield size={16} className="mt-0.5 text-[#909090]" />
                <span>Independent third-party tested</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col md:flex-row justify-between gap-3 text-xs text-zinc-500">
          <p>&copy; {new Date().getFullYear()} Hydro Health. All rights reserved.</p>
          <p className="font-semibold text-white uppercase tracking-wide">NOT FOR RESALE OR HUMAN CONSUMPTION &mdash; RESEARCH PURPOSES ONLY</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
